import { IconModule } from './../icon/icon.module';
import { TransitionNewModule } from "./../transitions-new/transition-new.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ExpandableComponent } from "./expandable.component";

@NgModule({
	declarations: [ExpandableComponent],
	imports: [CommonModule, TransitionNewModule, IconModule],
	exports: [ExpandableComponent]
})
export class ExpandableModule {}
